import React from 'react';
import { useSendEmailMutation } from '../api/sendEmailAPI';
interface SendEmailButtonProps {
  meetingID: string;
}

const SendEmailButton: React.FC<SendEmailButtonProps> = ({ meetingID }) => {
 
  const [sendEmail, { isLoading, data }] = useSendEmailMutation();

  const handleClick = async () => {
    
    try {
      if (!meetingID) {
        console.warn("⚠️ אין מזהה פגישה לשליחה");
        alert('אין פגישה נוכחית לשליחה');
        return;
      }

      await sendEmail(meetingID).unwrap();
      alert('המייל נשלח בהצלחה');
    } catch (err) {
      console.log("❌ שגיאה בשליחת המייל:", err);
      alert('!שליחת המייל נכשלה');
    }
  };

 

  return (
    <div>
      <button onClick={handleClick} disabled={isLoading} className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600">
        {isLoading ? 'שולח...' : 'שלח מייל'}
      </button>
      {/* {error && <p style={{ color: 'red' }}>אירעה שגיאה בשליחה</p>} */}
      {data && <p style={{ color: 'green' }}>ההודעה נשלחה ✔</p>}
    </div>
  );
};

export default SendEmailButton;
